import React, { useContext } from 'react'
import { withRouter, RouteComponentProps } from 'react-router'
import { DataProxy } from 'apollo-cache'

import ToastContext from 'containers/ToastManager/ToastContext'

import { useDeleteProjectMutation } from 'gqlTypes'
import { routes } from 'constants/routes'
import { ModalInjectedProps } from 'containers/ModalManager'
import ConfirmationDialog from 'components/ConfirmationDialog'
import { deleteWorkspaceProject } from 'modules/projects/operations'

interface DeleteProjectProps extends RouteComponentProps, ModalInjectedProps {
  projectId: string
  projectName: string
  workspaceId: string
}

const DeleteProject: React.FC<DeleteProjectProps> = props => {
  const {
    hideModal,
    isModalOpen,
    projectId,
    projectName,
    workspaceId,
    location,
    history,
  } = props
  const { showToast } = useContext(ToastContext)

  const handleOnComplete = async () => {
    showToast(`"${projectName}" Project deleted`)
    hideModal()

    if (
      location.pathname ===
      routes.WORKSPACE_PROJECT.create({ projectId, workspaceId })
    ) {
      history.push(routes.WORKSPACE_SHARES.create({ workspaceId: workspaceId }))
    }
  }

  const handleUpdate = (cache: DataProxy) => {
    deleteWorkspaceProject(cache, workspaceId, projectId)
  }

  const [deleteProject, { loading }] = useDeleteProjectMutation({
    redirectErrors: true,
    variables: { projectId },
    update: handleUpdate,
    onCompleted: handleOnComplete,
    onError: 'show-toast',
  })

  return (
    <ConfirmationDialog
      title={`Delete "${projectName}" Project?`}
      hideModal={hideModal}
      isModalOpen={isModalOpen}
      onConfirm={deleteProject}
      confirmButton={{
        text: 'Delete',
        loading,
        disabled: loading,
      }}>
      <p>
        Deleting a Project won’t delete your documents, which you can still find
        in All Documents. Sharing settings remain unchanged.
      </p>
    </ConfirmationDialog>
  )
}

export default withRouter(DeleteProject)
